const PROCESSING_TRANSACTION_TIMEOUT = 60;

export default {
  data() {
    return {
      timeout: null,
      showTimeout: false,
    };
  },
  methods: {
    openWithdrawalHistory() {
      this.getBalance();
      this.setCurrentPopup();
      this.$router.push({ name: 'account-history', query: { tabId: 'deposit-withdrawals' } });
    },
  },
  mounted() {
    this.timeout = setTimeout(() => {
      this.showTimeout = true;
    }, PROCESSING_TRANSACTION_TIMEOUT * 1000);
  },
  beforeDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/pending-requests/pending-request-withdrawal/components/processing-transaction/processing-transaction.js